import { render } from "./CloseAccountCreate.vue?vue&type=template&id=223702a9&scoped=true"
import script from "./CloseAccountCreate.vue?vue&type=script&lang=js"
export * from "./CloseAccountCreate.vue?vue&type=script&lang=js"

import "./CloseAccountCreate.vue?vue&type=style&index=0&id=223702a9&scoped=true&lang=css"
import "./CloseAccountCreate.vue?vue&type=style&index=1&id=223702a9&lang=css"

import exportComponent from "C:\\src\\Vue Project\\inalife-admin-dashboard\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-223702a9"]])

export default __exports__